import {useContext, useEffect} from 'react'
import {Col, Flex, Form, Modal, Row} from 'antd'
import {useIntl} from 'react-intl'
import {postRequest, putRequest} from '../../../../services/base'
import {NavContext} from '../../../../context/global_context'
import {CustomerContext, SELECT_CUSTOMER, UPDATE_CUSTOMER_DATA,} from '../context/context'
import InputText from '../../../common/InputText'
import TextArea from '../../../common/TextArea'
import Button from '../../../common/Button'
import {getLocalStorageData} from '../../../../utils/LocalStorageAccess'
import {MAKE_ID} from '../../../../constants/common'

const CustomerForm = (props) => {
  const intl = useIntl()
  const [state, dispatch] = useContext(CustomerContext)
  const [, navDispatch] = useContext(NavContext)
  const [form] = Form.useForm()

  const selected = state?.selected_customer || {}
  const storedMake = getLocalStorageData(MAKE_ID)

  const closeFormPopup = () => {
    dispatch({ type: SELECT_CUSTOMER, data: { selected_customer: {}, show_customer_form: false } })
    form.resetFields()
  }

  const getInitialValues = () => ({
    is_create: !selected?.id,
    id: selected?.id || undefined,
    name: selected?.name || '',
    make: storedMake || selected?.make || '',
    business_timezone: selected?.business_timezone || '',
    vin_dependent_make_model_tags: selected?.vin_dependent_make_model_tags || '',
  })

  useEffect(() => {
    if (!state.show_customer_form) return
    form.setFieldsValue(getInitialValues())
  }, [state.show_customer_form])

  const saveCustomer = async (values) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'customer.save' }),
        showLoader: true,
      },
      notification: {},
    })

    const formData = new FormData()
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value)
      }
    })

    let res = null
    if (selected?.id) {
      res = await putRequest(`/api/customer/${selected.id}/`, formData)
    } else {
      res = await postRequest(`/api/customer/`, formData)
    }

    navDispatch({
      type: 'loader',
      data: { showLoader: false },
      notification: {},
    })

    if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({
            id: selected?.id ? 'customer.updateSuccess' : 'customer.saveSuccess',
          }),
        },
      })

      if (selected?.id) {
        dispatch({
          type: UPDATE_CUSTOMER_DATA,
          data: {
            index: selected?.index ?? 0,
            customer: {
              ...selected,
              ...values,
              make: values.make || selected?.make,
            },
          },
        })
      } else {
        props.getCustomerListData()
        closeFormPopup()
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'customer.saveError' }),
        },
      })
    }
  }

  return (
    <Modal
      open={state.show_customer_form}
      title={
        selected?.id
          ? intl.formatMessage({ id: 'customer.updateTitle' })
          : intl.formatMessage({ id: 'customer.createTitle' })
      }
      width="50%"
      className="customer-form-modal"
      centered={true}
      footer={null}
      closable={true}
      onCancel={closeFormPopup}
    >
      <div className="container">
        <Form
          id="customer-form"
          name="customer-form"
          form={form}
          layout="vertical"
          onFinish={saveCustomer}
        >
          <InputText name="is_create" hidden={true} isRequired={false} />
          <InputText name="id" hidden={true} isRequired={false} />
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <InputText
                name="name"
                label={intl.formatMessage({ id: 'customer.name' })}
                isRequired={true}
              />
            </Col>
            <Col span={24}>
              <InputText
                name="make"
                label={intl.formatMessage({ id: 'customer.make' })}
                isRequired={true}
                readOnly={storedMake ? true : false}
              />
            </Col>
            <Col span={24}>
              <InputText
                name="business_timezone"
                label={intl.formatMessage({ id: 'customer.timezone' })}
                isRequired={false}
              />
            </Col>
            <Col span={24}>
              <TextArea
                name="vin_dependent_make_model_tags"
                label={intl.formatMessage({ id: 'customer.tags' })}
                isRequired={false}
                rows={4}
              />
            </Col>
            <Col span={24}>
              <Flex justify="end" className="py-4">
                <Button htmlType="submit" type="primary">
                  {intl.formatMessage({ id: 'customer.save' })}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default CustomerForm
